import React, { useState, useCallback } from 'react'
import { StyledProductNotes, StyledProductNotesToggle } from './ProductNotes.css'

const CHAR_LIMIT = 140

const ProductNotes = ({ notes }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const toggle = useCallback(() => setIsExpanded(prev => !prev), [])

  if (!notes) return null

  const isTruncatable = notes.length > CHAR_LIMIT
  const displayedNotes = isTruncatable && !isExpanded
    ? `${notes.slice(0, CHAR_LIMIT)}...`
    : notes

  return (
    <StyledProductNotes>
      <span style={{ fontWeight: 500 }}>Product Notes:</span>
      {` ${displayedNotes}`}
      {isTruncatable && (
        <StyledProductNotesToggle type="button" onClick={toggle}>
          {isExpanded ? 'View Less' : 'View More'}
        </StyledProductNotesToggle>
      )}
    </StyledProductNotes>
  )
}

export default ProductNotes
